

























































































import { Component, Vue } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import Alert from '@/components/Alert.vue'

@Component({
    components: {
        Alert,
    },
})
export default class ResetPassword extends Vue {
    apiService = new ApiService()
    pwdType = 'password'
    pass = {
        new: '',
        confirm: '',
    }
    errors = {
        new: '',
        confirm: '',
    }

    async handleReset(e) {
        e.preventDefault()
        this.cleanupErrors()

        if (this.pass.new === '' || this.pass.confirm === '') {
            if (this.pass.new === '') {
                this.errors.new = 'Ce champs est obligatoire'
            }
            if (this.pass.confirm === '') {
                this.errors.confirm = 'Ce champs est obligatoire'
            }
            return
        }

        if (this.pass.new !== this.pass.confirm) {
            this.errors.confirm =
                'Les deux mots de passe doivent être identiques'
            return
        }

        /**
         * TODO: l'API reset password
         */
        console.log('API Reset password')

        const token = this.$route.query.token
        try {
            const resp = await this.apiService.postResetPasswordChange(token, {
                plainPassword: this.pass.new,
            })
            ;(<Alert>this.$refs.alert).handleAlert(
                'success',
                'Votre mot de passe a bien été changé'
            )
            // redirection vers la page de connexion
            setTimeout(_ => {
                this.$router.push({ name: 'signin' })
            }, 2000)
        } catch (e) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                "Une erreur est survenue lors de l'envoi du nouveau mot de passe"
            )
        }
    }

    cleanupErrors() {
        this.errors = {
            new: '',
            confirm: '',
        }
    }

    showPwd() {
        if (this.pwdType === 'password') {
            this.pwdType = 'text'
        } else {
            this.pwdType = 'password'
        }
    }
}
